import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { useEffect } from "react";
import { reactPluginAtom } from "@store/HostAtoms";

interface AppInsightProps {
  children: React.ReactNode;
}

const AppInsightsProvider: React.FC<AppInsightProps> = ({ children }) => {
  const reactPlugin = reactPluginAtom();

  useEffect(() => {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: {}, // Configuration for React Plugin
        },
      },
    });
    appInsights.loadAppInsights();

    return () => {
      appInsights.unload(); // Cleanup when the component is unmounted
    };
  }, [reactPlugin]);
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );

};

export default AppInsightsProvider;